import { apiFetch } from "@/lib/api-fetch";
import { SUPABASE_URL } from "@/integrations/supabase/client";
import type { FreelancerPainel, FreelancerResumoRapido } from "@/types/freelancer-painel";

const BASE = SUPABASE_URL.replace(/\/$/, "");

export const RESUMO_RAPIDO_MAX_IDS = 200;

export const freelancerPainelApi = {
  /** WhatsApp e LinkedIn em poucas linhas, para a página inteira da lista de uma vez. */
  resumoRapido(ids: string[]): Promise<{ itens: Record<string, FreelancerResumoRapido> }> {
    return apiFetch(`${BASE}/freelancers/resumo-rapido`, {
      method: "POST",
      body: JSON.stringify({ ids: ids.slice(0, RESUMO_RAPIDO_MAX_IDS) }),
    });
  },

  painel(freelancerId: string): Promise<FreelancerPainel> {
    return apiFetch(`${BASE}/freelancers/${freelancerId}/painel`);
  },
};
